import { motion } from "framer-motion";

const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.5 },
};

const points = [
  {
    title: "Flexible usage-based pricing",
    desc: "Pay only for the documents you process.",
  },
  {
    title: "Custom plans",
    desc: "Tailored solutions designed for your organization’s workflows and processing requirements.",
  },
  {
    title: "Transparent pricing structure",
    desc: "Clear pricing with no hidden platform costs.",
  },
];

export default function PricingIntro() {
  return (
    <section className="section-padding">
      <div className="container-width">
        {/* Heading */}
        <motion.div className="max-w-3xl mb-16" {...fadeInUp}>
          <h2
            className="text-3xl md:text-5xl font-semibold tracking-tight leading-[1.1] text-neutral-950 mb-6"
            style={{ fontFamily: "Manrope, sans-serif" }}
          >
            Flexible Pricing Built for Every Stage of Growth
          </h2>

          <p className="text-lg md:text-xl leading-relaxed text-neutral-600">
            Bridge Format AIQ offers scalable pricing designed to support
            businesses from early automation to large-scale document processing.
          </p>
        </motion.div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {points.map((item, index) => (
            <motion.div
              key={index}
              className="
                rounded-[4px] 
                p-6 
                bg-primary
                text-white 
                shadow-md
                hover:shadow-lg
                transition
              "
              initial="initial"
              whileInView="whileInView"
              viewport={{ once: true }}
              variants={fadeInUp}
              transition={{ delay: index * 0.1 }}
            >
              <h3
                className="text-xl font-semibold mb-3 text-white"
                style={{ fontFamily: "Manrope, sans-serif" }}
              >
                {item.title}
              </h3>

              <p className="text-sm leading-relaxed text-white/80">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
